import * as React from 'react'

import { Tooltip } from '~/components/tooltip/Tooltip'

export type TOptionalTooltipWrapperProps = {
  hasTooltip?: boolean
  label?: React.ReactNode
  tooltipSide?: React.ComponentProps<typeof Tooltip.Content>['side']
}

export const OptionalTooltipWrapper = ({
  hasTooltip,
  label,
  tooltipSide,
  children
}: React.PropsWithChildren<TOptionalTooltipWrapperProps>) => {
  if (hasTooltip) {
    return (
      <Tooltip>
        <Tooltip.Trigger
          asChild
          onFocus={(e: React.FocusEvent) => {
            // Only show the tooltip on keyboard focus, not programmatic focus
            // (e.g. when a dialog auto-focuses this element on open).
            // The browser sets :focus-visible during keyboard navigation,
            // so if it is absent we know the focus was not from the keyboard
            // and call preventDefault() to tell Radix to skip opening the tooltip.
            if (!(e.currentTarget as Element).matches(':focus-visible')) {
              e.preventDefault()
            }
          }}
        >
          {children}
        </Tooltip.Trigger>
        <Tooltip.Content side={tooltipSide}>{label}</Tooltip.Content>
      </Tooltip>
    )
  }

  // children could be multiple elements/components,
  // so we need a fragment here.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}

OptionalTooltipWrapper.displayName = 'OptionalTooltipWrapper'
